'use es6';

import { REQUEST_COMPARISON_FORMS, RECEIVE_COMPARISON_FORMS, FAIL_GETTING_COMPARISON_FORMS, STORE_DASHBOARD_QUERY } from 'FormsUI/actions/ComparisonToolActions';
import { REQUESTED, SUCCEEDED, FAILED } from 'FormsCommonComponents/lib/RequestState';
export const initialState = {
  comparisonToolSearches: {},
  storedDashboardQuery: {}
};
export default ((state = initialState, {
  type = '',
  contentObject,
  comparisonForms,
  storedDashboardQuery,
  fails,
  startTimestamp,
  endTimestamp
}) => {
  switch (type) {
    case REQUEST_COMPARISON_FORMS:
      return Object.assign({}, state, {
        comparisonToolSearches: Object.assign({}, state.comparisonToolSearches, {
          [contentObject.guid]: state.comparisonToolSearches[contentObject.guid] || {
            REQUEST_STATE: REQUESTED
          },
          [JSON.stringify({
            guid: contentObject.guid,
            startTimestamp,
            endTimestamp
          })]: {
            REQUEST_STATE: REQUESTED
          }
        })
      });
    case RECEIVE_COMPARISON_FORMS:
      return Object.assign({}, state, {
        comparisonToolSearches: Object.assign({}, state.comparisonToolSearches, {
          [contentObject.guid]: state.comparisonToolSearches[contentObject.guid].REQUEST_STATE === SUCCEEDED ? state.comparisonToolSearches[contentObject.guid] : {
            REQUEST_STATE: SUCCEEDED,
            form: comparisonForms
          },
          [JSON.stringify({
            guid: contentObject.guid,
            startTimestamp,
            endTimestamp
          })]: {
            REQUEST_STATE: SUCCEEDED,
            form: comparisonForms
          }
        })
      });
    case FAIL_GETTING_COMPARISON_FORMS:
      return Object.assign({}, state, {
        comparisonToolSearches: Object.assign({}, state.comparisonToolSearches, {
          [contentObject.guid]: state.comparisonToolSearches[contentObject.guid] || {
            REQUEST_STATE: FAILED,
            fails
          },
          [JSON.stringify({
            guid: contentObject.guid,
            startTimestamp,
            endTimestamp
          })]: {
            REQUEST_STATE: FAILED,
            fails
          }
        })
      });
    case STORE_DASHBOARD_QUERY:
      return Object.assign({}, state, {
        storedDashboardQuery
      });
    default:
      return state;
  }
});